<div class="dialog-header" mat-dialog-title>
    <div class="header-icon" aria-hidden="true">
        <mat-icon class="material-icons-outlined" aria-hidden="true">preview</mat-icon>
    </div>
    <div class="header-copy">
        <h2>{{ 'FormPreview' | translate: {Default: "Form preview"} }}</h2>
        <p>{{ 'FormPreviewDescription' | translate: {Default: "This is how the form looks to your users. Nothing you enter here is saved."} }}</p>
    </div>
    <button type="button" mat-icon-button class="icon-button" appPreventDoubleClick (throttledClick)="close()" [attr.aria-label]="'Close' | translate: {Default: 'Close'}">
        <mat-icon class="material-icons-outlined" aria-hidden="true">close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <app-form-generator [formId]="formId"></app-form-generator>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-stroked-button class="rounded-button" appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
</mat-dialog-actions>
